import React, { useState, useRef } from 'react';
import { gql, useQuery, useMutation } from '@apollo/client';
import { DEFAULT_PREVIEW_FORM } from './index';
import QUERIES from "./QUERIES";
import FormPreview from 'global/components/FormPreview/index';
///Faileds/danielezaldivar/Sites/sonrisas/src/global/components/FormPreview.js
/*
<PREVIEW
  VARIABLES={{
    id: TPID
  }}
  PREVIEW_FORM, 
  TITLE, 
  SUB_TITLE
/>
*/

function PREVIEW(props) {     
  var {VARIABLES={}, PREVIEW_FORM, TITLE, SUB_TITLE, EDITABLE} = props;
  const { loading, error, data, refetch } = useQuery(QUERIES.single(), {
    variables: VARIABLES,
    fetchPolicy: "no-cache"
  });
  if (loading) return 'Loading...';
  if (error) return `Error! ${error.message}`;
  console.log(`PREVIEW USER data`,"\n\n",data,"\n\n");
        
  var NewObj = window.GlobalUtil.stripOutFromObj(data.failed, "__typename");  
  window.CurObj = {...NewObj, id: NewObj._id};
  window.CurRefetchEdit = refetch;        
  if(props.onLoad) props.onLoad(window.CurObj);                
  const TitleText = (TITLE !== undefined) ? TITLE : "Failed Preview";  
  const Title = <div className="headerWithButton">
    <div className="previewFormTitle">{TitleText}</div>
    <button className="button button1 btn-color5 editHeaderButton" onClick={()=>{
      window.GlobalUtil.triggerEvent("TemplateDBEvent", {
        NAME: "FAILEDS",
        TITLE: "Failed",
        FIELD: "failed",
        TYPE: "EDIT",
        ID: NewObj._id,
        // INCLUDE: [ //OPTIONAL
        //   {
        //     name: "Failed"
        //   }
        // ]
      });
      }}><i className="fas fa-edit"></i></button>
  </div>
  return (
    <FormPreview
      TITLE={EDITABLE ? Title : TitleText}
      SUB_TITLE={(SUB_TITLE !== undefined) ? SUB_TITLE : "Full Preview of current Failed."}
      NewObj={NewObj}
      PREVIEW_FORM={(PREVIEW_FORM ? PREVIEW_FORM : DEFAULT_PREVIEW_FORM())}
    />
  );
}



export default PREVIEW;